const devGlobalStatusBanner = {
  sys: {
    id: "global-status-banner-dev",
    publishedAt: "2025-01-01T00:00:00.000Z",
  },
  message: "[DEV] This is a hardcoded status banner for local development.",
  link: "https://www.swoosh-dev.nike",
  linkCta: "Learn More",
  color: "blue",
  isVisible: true,
};

const testGlobalStatusBanner = {
  sys: {
    id: "global-status-banner-test",
    publishedAt: "2025-01-01T00:00:00.000Z",
  },
  message: null,
  link: null,
  linkCta: null,
  color: null,
  isVisible: false,
};

const prodGlobalStatusBanner = {
  sys: {
    id: "global-status-banner-prod",
    publishedAt: "2025-01-01T00:00:00.000Z",
  },
  message: null,
  link: null,
  linkCta: null,
  color: null,
  isVisible: false,
};

function getGlobalStatusBannerForEnv() {
  switch (process.env.NEXT_PUBLIC_CURRENT_ENV) {
    case "production":
      return prodGlobalStatusBanner;
    case "test":
      return testGlobalStatusBanner;
    default:
      return devGlobalStatusBanner;
  }
}

export const makeGlobalStatusBannerApiCall = async () => {
  return getGlobalStatusBannerForEnv();
};
